"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importStar(require("react"));
const Divider_1 = __importDefault(require("@material-ui/core/Divider"));
const styles_1 = require("@material-ui/core/styles");
const Box_1 = __importDefault(require("../../../../layouts/Box"));
const Link_1 = __importDefault(require("../../../Link"));
const useStyles = styles_1.makeStyles((theme) => ({
    header: {
        fontSize: '18px',
        padding: '20px 56px 20px 30px',
        paddingRight: theme.spacing(3),
        paddingLeft: theme.spacing(3),
        '& .MuiLink-root': {
            fontSize: '18px',
            color: theme.palette.grey[900],
        },
        '& .MuiLink-root:hover': {
            color: theme.palette.secondary.main,
        },
    },
}));
const SideNavigationTemplate = ({ header, children }) => {
    const styles = useStyles();
    const headerContent = react_1.useMemo(() => (react_1.default.createElement(Box_1.default, { className: styles.header, color: "grey.900" }, header.href ? (react_1.default.createElement(Link_1.default, { href: header.href, underlineHover: false },
        react_1.default.createElement("b", null, header.text))) : (react_1.default.createElement("b", null, header.text)))), [header, styles.header]);
    return (react_1.default.createElement(Box_1.default, null,
        headerContent,
        react_1.default.createElement(Divider_1.default, null),
        children));
};
exports.default = SideNavigationTemplate;
//# sourceMappingURL=index.js.map